import React, { useEffect } from 'react'
import { Banner } from '@arnsbogroup/react-voicearchive'
import useValidate, { is } from '@arnsbogroup/react-voicearchive/hooks/useValidate'
import { useIntl } from 'react-intl'
import messages from "./messages";

const RequiredFields = ( { customer, isCustomerDataComplete } ) => {
    const { formatMessage } = useIntl()

    const [validations, validate] = useValidate(customer, {
        name: [is.present],
        address: [is.present],
        zip: [is.present],
        city: [is.present],
        country: [is.present],
        phone: [is.present],
        email: [is.present, is.email]
    }, true)

    const missingFields = Object.entries(validations)
        .map(([key, _]) => ({
            name: 'Name',
            address: 'Address',
            zip: 'Zip code',
            city: 'City',
            country: 'Country',
            phone: 'Finance phone',
            email: 'Finance email'
        })[key])

    useEffect(() => isCustomerDataComplete(!missingFields.length), [missingFields])

    if (!customer || !missingFields.length) {
        return null
    }

    return (
        <div className="p-4 text-center flex flex-col md:flex-row">
            <Banner
                title={formatMessage(messages.incompleteTitle)}
                subtitle={missingFields.join(', ')}
                state="warning"
            />
        </div>
    )
}

export default RequiredFields